import { render, staticRenderFns } from "./SubTag.vue?vue&type=template&id=79de3073"
import script from "./SubTag.vue?vue&type=script&lang=js"
export * from "./SubTag.vue?vue&type=script&lang=js"
import style0 from "./SubTag.vue?vue&type=style&index=0&id=79de3073&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports